<template>
  <div class="q-gutter-y-xl">
    <VehicleListingsCustomPhrase
      v-for="component in customPhraseComponents"
      :key="component.key"
      :custom-phrase="component.customPhrase"
      :title="component.title.charAt(0).toUpperCase() + component.title.slice(1)"
      :horizontal-scrollable="horizontalScrollable"
      :enable-vehicle-count="enableVehicleCount"
      :tracking-id="component.trackingId"
      :enable-view-all="enableViewAll"
    />
  </div>
</template>

<script>
import VehicleListingsCustomPhrase from "@/components/VehicleListings/VehicleListingsCustomPhrase.vue";
import globalMixin from "@/mixins/index";
import axios from "axios";

export default {
  name: "VehicleListingsCustomPhrasesTrio",
  mixins: [globalMixin],
  components: { VehicleListingsCustomPhrase },
  props: {
    // Pass-through props to control child components
    horizontalScrollable: {
      type: Boolean,
      default: true
    },
    enableVehicleCount: {
      type: Boolean,
      default: false
    },
    trackingId: {
      type: String,
      default: "custom-phrases-trio"
      // This will be appended with index for each phrase
    },
    enableViewAll: {
      type: Boolean,
      default: false
      // Shows "View All" button AND enables navigation to search
    }
  },
  data() {
    return {
      customPhraseComponents: []
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.fetchCustomPhrases();
  },
  methods: {
    fetchCustomPhrases() {
      axios
        .post(
          "https://api-v2.jumpfeed.com/network/publisher/carscience-search-suggestions-open-router-v2",
          {
            visitor_profile: {
              clickCounts: this.generateVisitorProfile(),
              filterCounts: this.$store.getters[
                "search/searchFiltersHistoryByClauseCount"
              ],
              filterHistory: this.$store.getters[
                "search/searchFiltersHistory"
              ].slice(0, 20)
            },
            num_suggestions: 3
          }
        )
        .then(response => {
          let output = response.data.data;
          output.reply.forEach((suggestion, i) => {
            this.customPhraseComponents.push({
              title: suggestion,
              key: i + "_vehicle-listings-custom-phrase",
              customPhrase: suggestion,
              trackingId: `${this.trackingId}-` + suggestion.toLowerCase().replace(/\s+/g, "-"),
              enableViewAll: this.enableViewAll,
              enableVehicleCount: this.enableVehicleCount,
              horizontalScrollable: this.horizontalScrollable
            });
          });
        })
        .catch(e => {
          console.error("Failed to fetch custom phrases:", e);
        });
    }
  }
};
</script>
